/**
 * Utilitaire de debug pour vérifier l'état de l'utilisateur connecté
 * À utiliser dans la console du navigateur : debugUser()
 */

// Fonction globale pour débugger l'utilisateur
window.debugUser = function() {
  console.log('🔍 Debug de l\'utilisateur connecté...\n');
  
  // Vérifier le token
  const token = localStorage.getItem('token');
  if (!token) {
    console.log('❌ Aucun token trouvé - utilisateur non connecté');
    return;
  }
  
  console.log('✅ Token présent');
  
  // Décoder le token JWT (attention: ne pas utiliser en production pour la sécurité)
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    console.log('👤 Payload du token:', {
      id: payload.id,
      phoneNumber: payload.phoneNumber,
      role: payload.role,
      iat: new Date(payload.iat * 1000).toLocaleString(),
      exp: new Date(payload.exp * 1000).toLocaleString()
    });
  } catch (error) {
    console.log('⚠️  Impossible de décoder le token');
  }
  
  // Vérifier l'AuthContext si disponible
  const authContextData = window.localStorage.getItem('authContext');
  if (authContextData) {
    try {
      const authData = JSON.parse(authContextData);
      console.log('🏪 Données AuthContext:', authData);
    } catch (error) {
      console.log('⚠️  AuthContext invalide');
    }
  }
  
  // Test d'appel API pour vérifier les permissions
  fetch('/api/admin/users', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(response => {
    console.log(`📡 Test API /api/admin/users: ${response.status}`);
    if (response.status === 200) {
      console.log('✅ Accès admin confirmé');
      return response.json();
    } else if (response.status === 403) {
      console.log('❌ Accès refusé - permissions insuffisantes');
    } else if (response.status === 401) {
      console.log('❌ Non authentifié - token invalide');
    } else {
      console.log(`⚠️  Réponse inattendue: ${response.status}`);
    }
    return null;
  })
  .then(data => {
    if (data) {
      console.log(`📊 ${data.count || 0} utilisateurs trouvés dans le système`);
    }
  })
  .catch(error => {
    console.log('💥 Erreur lors du test API:', error);
  });
  
  // Instructions d'aide
  console.log('\n📚 Commandes utiles:');
  console.log('  • debugUser() - Afficher ces informations');
  console.log('  • localStorage.clear() - Effacer le cache et se reconnecter');
  console.log('  • location.reload() - Recharger la page');
  
  console.log('\n🎯 Pour un admin, vous devriez voir:');
  console.log('  • ✅ Token présent et valide');
  console.log('  • ✅ API /api/admin/users retourne 200');
  console.log('  • ✅ Menu complet avec "Gestion des utilisateurs"');
};

// Fonction pour tester les permissions depuis la console
window.testPermissions = function() {
  const permissions = [
    'users.read',
    'users.create', 
    'students.read',
    'teachers.read',
    'payments.read',
    'bulletins.read'
  ];
  
  console.log('🔑 Test des permissions...\n');
  
  permissions.forEach(permission => {
    fetch(`/api/test-permission/${permission}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then(response => {
      console.log(`${permission}: ${response.status === 200 ? '✅' : '❌'}`);
    })
    .catch(() => {
      console.log(`${permission}: ❓ (erreur de test)`);
    });
  });
};

// Fonction pour forcer une reconnexion
window.forceReconnect = function() {
  console.log('🔄 Reconnexion forcée...');
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = '/login';
};

console.log('🛠️  Utilitaires de debug chargés:');
console.log('   • debugUser() - Debug complet de l\'utilisateur');
console.log('   • testPermissions() - Test des permissions');
console.log('   • forceReconnect() - Forcer une reconnexion');
console.log('\n💡 En cas de problème, tapez debugUser() dans la console');